import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE = 'Meet For Mahjong';

// Static routes → browser-tab title. Pages that already render <SEO /> will
// override this on mount, so this is purely a safety net for the routes that
// don't (admin, member, auth flows, etc.).
const STATIC = {
  '/': SITE,
  '/about': `About | ${SITE}`,
  '/how-it-works': `How It Works | ${SITE}`,
  '/pricing': `Membership | ${SITE}`,
  '/faq': `FAQ | ${SITE}`,
  '/contact': `Contact | ${SITE}`,
  '/terms': `Terms & Conditions | ${SITE}`,
  '/terms-and-conditions': `Terms & Conditions | ${SITE}`,
  '/privacy': `Privacy Policy | ${SITE}`,
  '/privacy-policy': `Privacy Policy | ${SITE}`,
  '/instructors': `Instructors | ${SITE}`,
  '/play-locations': `Play Locations | ${SITE}`,
  '/login': `Log In | ${SITE}`,
  '/register': `Sign Up | ${SITE}`,
  '/forgot-password': `Forgot Password | ${SITE}`,  // pragma: allowlist secret
  '/reset-password': `Reset Password | ${SITE}`,  // pragma: allowlist secret
  '/dashboard': `Dashboard | ${SITE}`,
  '/profile': `My Profile | ${SITE}`,
  '/find-players': `Find Players | ${SITE}`,
  '/messages': `Messages | ${SITE}`,
  '/settings': `Settings | ${SITE}`,
  '/subscription': `Subscription | ${SITE}`,
  '/payment/success': `Payment Confirmed | ${SITE}`,
  '/referrals': `Refer a Friend | ${SITE}`,
  '/events': `Events | ${SITE}`,
  '/events/post': `Post an Event | ${SITE}`,
  '/events/post-success': `Event Posted | ${SITE}`,
  '/events/my-events': `My Events | ${SITE}`,
  '/forum': `Discussion Board | ${SITE}`,
  '/forum/new': `New Thread | ${SITE}`,
  '/admin': `Admin Dashboard | ${SITE}`,
  '/admin/users': `User Management | Admin | ${SITE}`,
  '/admin/subscriptions': `Subscriptions | Admin | ${SITE}`,
  '/admin/moderation': `Message Moderation | Admin | ${SITE}`,
  '/admin/reports': `User Reports | Admin | ${SITE}`,
  '/admin/events': `Events | Admin | ${SITE}`,
  '/admin/review-moderation': `Reviews & Reports | Admin | ${SITE}`,
};

// Dynamic routes — mapped via prefix lookup. Specific page components can
// still override (e.g. ForumThreadPage could set the thread title once loaded).
const DYNAMIC = [
  ['/messages/', `Messages | ${SITE}`],
  ['/player/', `Player Profile | ${SITE}`],
  ['/events/', `Event Details | ${SITE}`],
  ['/forum/thread/', `Discussion | ${SITE}`],
  ['/forum/', `Discussion Board | ${SITE}`],
  ['/admin/', `Admin | ${SITE}`],
];

export default function RouteTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (STATIC[pathname]) {
      document.title = STATIC[pathname];
      return;
    }
    const match = DYNAMIC.find(([prefix]) => pathname.startsWith(prefix));
    document.title = match ? match[1] : SITE;
  }, [pathname]);

  return null;
}
